import type { TrialIssue } from "@/lib/trial-schema";

/**
 * Issues whose `path` belongs to `stages[idx]` (or a field nested inside
 * it). Shared by the floor-list badges and the floor card's own issue
 * panel so both read the exact same rule for "does this issue belong to
 * this floor" — see session 2's note that `path` uses JS index notation
 * specifically so this kind of prefix match is possible.
 */
export function issuesForStage(issues: TrialIssue[], idx: number): TrialIssue[] {
  const prefix = `stages[${idx}]`;
  return issues.filter((i) => i.path === prefix || i.path.startsWith(`${prefix}.`) || i.path.startsWith(`${prefix}[`));
}
